import React, { useState, useEffect } from 'react'
import ReactGA from 'react-ga4';
import { AppBar, Checkbox, CircularProgress, FormControl, FormControlLabel, InputLabel, MenuItem, Select, Tab, Tabs } from '@mui/material';
import axios from "axios"
import { Auth } from "aws-amplify";
import { useTranslation } from "react-i18next";

import FilterListIcon from '@mui/icons-material/FilterList';

import CompareReport from './CompareReport';
import BarChart from '../../BarChart';
import LineChart from '../../LineChart';

const Report = ({ superAdminInfo }) => {
  const [reportData, setReportData] = useState("")
  const [reportError, setReportError] = useState("")
  const [testId, setTestId] = useState(superAdminInfo.allTests ? superAdminInfo.allTests[0].testId : null)
  const [tabValue, setTabValue] = useState(0);
  const [region, setRegion] = useState("");
  const [std, setStd] = useState("");
  const [lang, setLang] = useState(superAdminInfo.allTests ? superAdminInfo.allTests[0].lang.sort()[0] : "");
  const [metric, setMetric] = useState("");
  const [chartType, setChartType] = useState("");
  const [showPhrasingNotQualified, setShowPhrasingNotQualified] = useState(true);

  const { t } = useTranslation();
  
  useEffect(() => {
    if( !reportError && (!reportData || (tabValue===1 && region && (reportData!=="" && reportData.region !== region)))){
      if(superAdminInfo.allTests){
        Auth.currentSession()
        .then((data) => {
          const jwtToken = data.idToken.jwtToken;
          
          const getAllRegionReportData = async(superAdminId, testId, lang) => {
            try {
              const response =  await axios.get("https://zk1128nq2f.execute-api.ap-south-1.amazonaws.com/alpha/superAdmin/"+superAdminId+"/result?testId="+testId+"&allRegions=1&ver=2", {
                  headers: {
                      'Content-Type': 'application/json',
                      'Authorization': jwtToken
                  }
              });
              // // console.log("Report Data: ",response.data["report"])

              // console.log(response)
              // Remove keys from the metric object
              // let metricFilters = []
              let metricFilters = ["pace", "accuracy"]
              let filteredMetric = Object.fromEntries(
                Object.entries(response.data.report.metric).map(([metricLang, metrics]) => {
                  let filtered = Object.fromEntries(
                    Object.entries(metrics).filter(([key]) => !metricFilters.includes(key))
                  );
                  return [metricLang, filtered];
                })
              );
              let reportData = {...response.data["report"],
                "metric": filteredMetric
              }
              // console.log(reportData)
              setStd(reportData["allRegions"][lang].map(item => item.std).sort((a, b) => a - b)[0] || "")
              let metric = Object.keys(reportData["metric"][lang])[0]
              setMetric(metric)
              setChartType(reportData["metric"][lang][metric][0])
              setReportData(reportData)
            }
            catch (error) {
              console.log(error)
              if(error.response.status === 404) setReportError(t("superAdmin.results.error_api_resultNotFound"))
              else console.log(error)
            }
          }
          const getRegionAllSchoolData = async(superAdminId, testId, region, lang) => {
            try {
              const response =  await axios.get("https://zk1128nq2f.execute-api.ap-south-1.amazonaws.com/alpha/superAdmin/"+superAdminId+"/result?testId="+testId+"&region="+region+"&ver=2", {
                  headers: {
                      'Content-Type': 'application/json',
                      'Authorization': jwtToken
                  }
              });
              // // console.log("Report Data: ",response.data["report"])

              setStd(response.data["report"]["allSchools"][lang].map(item => item.std).sort((a, b) => a - b)[0] || "")
              setReportData(prev => ({...prev,
                  "region": response.data["report"]["region"],
                  "allSchools": response.data["report"]["allSchools"]
                }))
            }
            catch (error) {
              if(error.response.status === 404) setReportError(t("superAdmin.results.error_api_resultNotFound"))
              else console.log(error)
            }
          }
          if(!reportData) getAllRegionReportData(superAdminInfo.superAdmin.superAdminId, testId, lang)
          if(tabValue===1 && region!=="") getRegionAllSchoolData(superAdminInfo.superAdmin.superAdminId, testId, region, lang)
          
        })
        .catch((err) => console.log(err));
      }
      else{
        alert(t("commonItems.error_noTestCompleted"))
        window.location.replace("/");
      }
    }
    
  }, [t, superAdminInfo, testId, region, tabValue, reportData, reportError, lang]);

  const handleTabChange = (event, newValue) => {
    if(newValue === 1 && ["ZIET BHUBANESWAR", "ZIET CHANDIGARH", "ZIET GWALIOR", "ZIET MUMBAI", "ZIET MYSORE"].includes(region)) setRegion("")
    setTabValue(newValue);
    // console.log(event.target.firstChild.data)
    ReactGA.event({
      category: 'Super Admin Results Tab',
      action: 'Result Tab Switch',
      label: event.target.firstChild.data
    });
  };

  const handleTestIdChange = (e) => {
    setStd("");
    setRegion("");
    setMetric("");
    setChartType("");
    setReportData("");
    setReportError("");
    let selectedTestLangs = superAdminInfo.allTests.filter(item => item.testId === e.target.value)[0].lang
    if(!selectedTestLangs.includes(lang)) setLang(selectedTestLangs.sort()[0])
    setTestId(e.target.value);
  };

  const handleStdChange = (e) => {
    setStd(e.target.value);
  };

  const handleLangChange = (e) => {
    let lang = e.target.value
    if(reportData!==""){
      let stds = [...new Set(reportData["allRegions"][lang].map(item => item.std))].sort((a, b) => a - b)
      if(!stds.includes(std)) setStd(stds[0])
      let metrics = Object.keys(reportData["metric"][lang])
      if(!metrics.includes(metric)){
        setMetric(metrics[0])
        setChartType(reportData["metric"][lang][metrics[0]][0])
      }
    }
    setLang(lang);
  };

  const handleRegionChange = (e) => {
    setRegion(e.target.value);
    if(tabValue===1 && e.target.value!=="" && reportData.region !== e.target.value) setReportData(prev => ({...prev, "allSchools": ""}))
  };

  const handleMetricChange = (e) => {
    if(reportData!==""){
      let chartTypes = reportData["metric"][lang][e.target.value]
      if(!chartTypes.includes(chartType)) setChartType(chartTypes[0])
    }
    setMetric(e.target.value);
  };

  const handleChartTypeChange = (e) => {
    setChartType(e.target.value);
  };

  const handleShowPhrasingNotQualified = (e) => {
    setShowPhrasingNotQualified(e.target.checked);
  };

  var filteredReportData = reportData
  if(lang && std!== "") filteredReportData = {
    "allRegions": reportData["allRegions"][lang].filter(item => item.std === std),
    "allSchools": reportData.hasOwnProperty('allSchools') && reportData["allSchools"]!=="" ? reportData["allSchools"][lang].filter(item => item.std === std) : "",
    "overall": reportData["overall"][lang].filter(item => item.std === std)[0],
    "thresholds": reportData["thresholds"][lang].filter(item => item.std === std)[0]
  }

  return (
    <div className='report superAdminReport innerContent'>
      <h2 style={{textAlign: "center", color: "#0288D1", borderRadius: "15px", border: "1px solid"}}>
        {t("superAdmin.results.title")}
      </h2>
      <div className="chartArea">
        <div>
          <AppBar position="static" sx={{mt: "0.5rem", backgroundColor: "#001162"}}>
            <Tabs value={tabValue} onChange={handleTabChange} sx={{minHeight: "30px"}} variant='fullWidth' textColor="inherit" TabIndicatorProps={{style: {backgroundColor: "#7ed46a", height: "4px"}}}>
              <Tab label={t("commonItems.tabLabel_regionWise")} sx={{fontSize: "inherit", minHeight: "30px"}}/>
              <Tab label={t("commonItems.tabLabel_schoolWise")} sx={{fontSize: "inherit", minHeight: "30px"}}/>
              <Tab label={t("commonItems.tabLabel_compare")} sx={{fontSize: "inherit", minHeight: "30px"}}/>
            </Tabs>
          </AppBar>
          { tabValue !== 2 ?
              <div style={{display: "flex", flexDirection: "column", paddingTop: "0.5rem"}}>
                {/* <h4 style={{color: "#dc3545"}}>Note: Invalid attempts are not considered in the results.</h4> */}
                <p style={{fontSize: "14px", color: "#dc3545"}}>
                  {superAdminInfo.allTests && superAdminInfo.allTests.filter(item=> item.testId === testId)[0].status === 4 ?
                      t("commonItems.info_resultGenerated", { 
                        date: new Date(superAdminInfo.allTests.filter(item=> item.testId === testId)[0].resultGeneratedDate).toLocaleDateString("en-GB", { dateStyle: "long" }) 
                      })
                  :
                    superAdminInfo.allTests &&     
                      t("commonItems.info_resultGenerated", { 
                        date: new Date(superAdminInfo.allTests.filter(item=> item.testId === testId)[0].uploadEndDate).toLocaleDateString("en-GB", { dateStyle: "long" }) 
                      })
                  }
                </p>
              </div>
            :
              <div style={{display: "flex", flexDirection: "column", paddingTop: "0.5rem"}}>
                <h4 style={{color: "#dc3545"}}>
                  {t("commonItems.info_compareTab")}
                </h4>
              </div>
          }
        </div>
        { tabValue === 2 ?
          <CompareReport superAdminInfo={superAdminInfo}/>
        :
          <>
            <div className="filters">
              <div className="forms">
                <h4 style={{display: "flex", justifyContent: "center", alignItems: "center", gap: "0.25rem"}}>
                  <FilterListIcon fontSize="small"/>
                  <span style={{height: "100%"}}>{t("commonItems.filterLabel")}</span> 
                </h4>
                <FormControl sx={{ m: 1, minWidth: 150}} size="small">
                  <InputLabel id="testNameFilterLabel">{t("commonItems.dropdownLabel_testName")}</InputLabel>
                  <Select
                    labelId="testIdFilterLabel"
                    id="testIdFilter"
                    value={testId ? testId : ""}
                    onChange={handleTestIdChange}
                    autoWidth
                    label={t("commonItems.dropdownLabel_testName")}
                  >
                    {/* <MenuItem value="">
                      <em>None</em>
                    </MenuItem> */}
                    {/* getting all unique std values from data */}
                    {superAdminInfo.allTests &&
                      superAdminInfo.allTests.map(item => item.testName).map((item, i) => {
                      return <MenuItem key={i} value={superAdminInfo.allTests[i].testId}>{item}</MenuItem>
                      })
                    }
                  </Select>
                </FormControl>
                <FormControl sx={{ m: 1, minWidth: 150}} size="small">
                  <InputLabel id="langFilterLabel">{t("commonItems.dropdownLabel_lang")}</InputLabel>
                  <Select
                    labelId="langFilterLabel"
                    id="langFilter"
                    value={lang}
                    onChange={handleLangChange}
                    autoWidth
                    label={t("commonItems.dropdownLabel_lang")}
                  >
                    {superAdminInfo.allTests &&
                      superAdminInfo.allTests.filter(item => item.testId === testId)[0].lang.sort().map((item, i) => {
                        return <MenuItem key={i} value={item}>{superAdminInfo.allLangs[item]}</MenuItem>   
                      })
                    }
                  </Select>
                </FormControl>
                <FormControl sx={{ m: 1, minWidth: 85}} size="small">
                  <InputLabel id="stdFilterLabel">{t("commonItems.dropdownLabel_class")}</InputLabel>
                  <Select
                    labelId="stdFilterLabel"
                    id="stdFilter"
                    value={std}
                    onChange={handleStdChange}
                    autoWidth
                    label={t("commonItems.dropdownLabel_class")}
                  >
                    {/* <MenuItem value="">
                      <em>None</em>
                    </MenuItem> */}
                    {/* getting all unique std values from data */}
                    { reportData!=="" && lang &&
                      [...new Set(reportData["allRegions"][lang].map(item => item.std))].sort((a, b) => a - b).map((item, i) => {
                      return <MenuItem key={i} value={item}>{item}</MenuItem>
                      })
                    }
                  </Select>
                </FormControl>
                <FormControl sx={{ m: 1, minWidth: 120}} size="small">
                  <InputLabel id="metricFilterLabel">{t("commonItems.dropdownLabel_metric")}</InputLabel>
                  <Select
                    labelId="metricFilterLabel"
                    id="metricFilter"
                    value={metric}
                    onChange={handleMetricChange}
                    autoWidth
                    label={t("commonItems.dropdownLabel_metric")}
                  >
                    { reportData!=="" && lang &&
                      Object.keys(reportData["metric"][lang]).map((item, i) => {
                        return <MenuItem key={i} value={item}>{
                          item==="wcpm" ? "WCPM" : 
                          item==="phrasing" ? "Phrasing" : 
                          item==="pace" ? "Pace" :
                          item==="accuracy" ? "Accuracy" :
                          item 
                        }</MenuItem>
                      })
                    }
                  </Select>
                </FormControl>
                <FormControl sx={{ m: 1, minWidth: 130}} size="small">
                  <InputLabel id="chartTypeFilterLabel">{t("commonItems.dropdownLabel_chartType")}</InputLabel>
                  <Select
                    labelId="chartTypeFilterLabel"
                    id="chartTypeFilter"
                    value={chartType}
                    onChange={handleChartTypeChange}
                    autoWidth
                    label={t("commonItems.dropdownLabel_chartType")}
                  >
                    { reportData!=="" && lang && metric &&
                      reportData["metric"][lang][metric].map((item, i) => {
                        return <MenuItem key={i} value={item}>{item==="bar" ? "Bar" : item==="line" ? "Line" : item }</MenuItem>
                      })
                    }
                  </Select>
                </FormControl>
                <FormControl sx={{ m: 1, minWidth: 150}} size="small">
                  <InputLabel id="regionFilterLabel">{t("commonItems.dropdownLabel_region")}</InputLabel>
                  <Select
                    labelId="regionFilterLabel"
                    id="regionFilter"
                    value={region}
                    onChange={handleRegionChange}
                    autoWidth
                    label={t("commonItems.dropdownLabel_region")}
                  >
                    <MenuItem value="">
                      <em>None</em>
                    </MenuItem>
                    {/* getting all unique region values from data */}
                    { reportData!=="" && 
                      [...new Set(filteredReportData["allRegions"].map((item) => item.region))].map((item, i) => {
                        return <MenuItem key={i} value={item}>{item}</MenuItem>
                      })
                    }
                    {/* hard coded values for ziets */}
                    {(reportData!=="" && superAdminInfo.superAdmin.superAdminId === 24 && tabValue === 0) &&
                      [
                        <MenuItem key={1} value="ZIET BHUBANESWAR">ZIET BHUBANESWAR</MenuItem>,
                        <MenuItem key={2} value="ZIET CHANDIGARH">ZIET CHANDIGARH</MenuItem>,
                        <MenuItem key={3} value="ZIET GWALIOR">ZIET GWALIOR</MenuItem>,
                        <MenuItem key={4} value="ZIET MUMBAI">ZIET MUMBAI</MenuItem>,
                        <MenuItem key={5} value="ZIET MYSORE">ZIET MYSORE</MenuItem>
                      ]
                    }
                    {/* hard coded values for ziets */}
                  </Select>
                </FormControl>
                {metric === "phrasing" && chartType === "bar" &&
                  <FormControlLabel 
                    control={
                      <Checkbox 
                        checked={showPhrasingNotQualified}
                        onChange={handleShowPhrasingNotQualified}
                      />
                    } 
                    label={t("commonItems.checkboxLabel_showNotQualfied")}
                    sx={{ml: -0.5, mr: 1}}
                  />
                }
              </div>
            </div>
            <div className="charts">
              {!reportError ? 
                <>
                  {(reportData!=="" && lang && tabValue === 0) &&
                    <>
                      {metric === "wcpm" &&
                        <> 
                          {chartType === "bar" &&
                            <BarChart
                              chartData = {
                                [[
                                  filteredReportData.overall.wcpmCat1, filteredReportData.overall.wcpmCat2, filteredReportData.overall.wcpmCat3, filteredReportData.overall.wcpmCat4, filteredReportData.overall.wcpmCat5, filteredReportData.overall.wcpmTotal
                                ]].concat(
                                  [...new Set(filteredReportData["allRegions"].map((item) => item.region))]
                                    .filter(r => {
                                      return region==="" ? true 
                                      : region === "ZIET BHUBANESWAR" ? ["BHUBANESWAR", "GUWAHATI", "KOLKATA", "RANCHI", "SILCHAR", "TINSUKIA"].includes(r)
                                      : region === "ZIET CHANDIGARH" ? ["CHANDIGARH", "DEHRADUN", "DELHI", "GURUGRAM", "JAMMU"].includes(r) 
                                      : region === "ZIET GWALIOR" ? ["AGRA", "BHOPAL", "JABALPUR", "LUCKNOW", "VARANASI"].includes(r)
                                      : region === "ZIET MUMBAI" ? ["AHMEDABAD", "JAIPUR", "MUMBAI", "PATNA", "RAIPUR"].includes(r)
                                      : region === "ZIET MYSORE" ? ["BENGALURU", "CHENNAI", "ERNAKULAM", "HYDERABAD"].includes(r)
                                      : region === r
                                    })
                                    .map(region => filteredReportData["allRegions"].filter(item=> item.region === region)
                                    .reduce((acc, item) => {
                                      return [ acc[0] + item.wcpmCat1, acc[1] + item.wcpmCat2, acc[2] + item.wcpmCat3, acc[3] + item.wcpmCat4, acc[4] + item.wcpmCat5, acc[5] + item.wcpmTotal ]
                                    }, [0, 0, 0, 0, 0, 0]))
                                  )
                              }
                              labelData = { 
                                ["OVERALL"].concat( 
                                  [...new Set(filteredReportData["allRegions"].map((item) => item.region))]
                                    .filter(r => {
                                      return region==="" ? true 
                                        : region === "ZIET BHUBANESWAR" ? ["BHUBANESWAR", "GUWAHATI", "KOLKATA", "RANCHI", "SILCHAR", "TINSUKIA"].includes(r)
                                        : region === "ZIET CHANDIGARH" ? ["CHANDIGARH", "DEHRADUN", "DELHI", "GURUGRAM", "JAMMU"].includes(r) 
                                        : region === "ZIET GWALIOR" ? ["AGRA", "BHOPAL", "JABALPUR", "LUCKNOW", "VARANASI"].includes(r)
                                        : region === "ZIET MUMBAI" ? ["AHMEDABAD", "JAIPUR", "MUMBAI", "PATNA", "RAIPUR"].includes(r)
                                        : region === "ZIET MYSORE" ? ["BENGALURU", "CHENNAI", "ERNAKULAM", "HYDERABAD"].includes(r)
                                        : region === r
                                    })
                                )
                              }
                              catLabelData={
                                [
                                  filteredReportData.thresholds.wcpmT1 < 0 ? "Invalid Entries" : t("commonItems.chartCatLabel_bar_wcpm1", {t1: 0, t2: filteredReportData.thresholds.wcpmT1}),
                                  t("commonItems.chartCatLabel_bar_wcpm1", {t1: filteredReportData.thresholds.wcpmT1+1, t2: filteredReportData.thresholds.wcpmT2}),
                                  t("commonItems.chartCatLabel_bar_wcpm1", {t1: filteredReportData.thresholds.wcpmT2+1, t2: filteredReportData.thresholds.wcpmT3}),
                                  filteredReportData.thresholds.wcpmT4 < 0 ?  t("commonItems.chartCatLabel_bar_wcpm2", {t1: filteredReportData.thresholds.wcpmT3+1}) : t("commonItems.chartCatLabel_bar_wcpm1", {t1: filteredReportData.thresholds.wcpmT3+1, t2: filteredReportData.thresholds.wcpmT4}),
                                  filteredReportData.thresholds.wcpmT4 < 0 ? "-" : t("commonItems.chartCatLabel_bar_wcpm2", {t1: filteredReportData.thresholds.wcpmT4+1})
                                ]
                              }
                              title = {"WCPM - " + t("superAdmin.results.regionWiseTab.chartTitle") + " - " + superAdminInfo.allLangs[lang]}
                              xLabel = {region==="" ? t("superAdmin.results.regionWiseTab.chartXLabel_other") : t("superAdmin.results.regionWiseTab.chartXLabel_one") + " - " + region}
                              yLabel = {t("superAdmin.results.regionWiseTab.chartYLabel", {unit: "%"})}
                              chartName={region!=="" ? region + " - Class-" + std : "Class-" + std}
                              chartInfo={
                                filteredReportData.allRegions[0].recCount && 
                                  t("commonItems.info_chart", { 
                                    tested: filteredReportData.allRegions.filter(item => {
                                              return region==="" ? true 
                                                : region === "ZIET BHUBANESWAR" ? ["BHUBANESWAR", "GUWAHATI", "KOLKATA", "RANCHI", "SILCHAR", "TINSUKIA"].includes(item.region)
                                                : region === "ZIET CHANDIGARH" ? ["CHANDIGARH", "DEHRADUN", "DELHI", "GURUGRAM", "JAMMU"].includes(item.region) 
                                                : region === "ZIET GWALIOR" ? ["AGRA", "BHOPAL", "JABALPUR", "LUCKNOW", "VARANASI"].includes(item.region)
                                                : region === "ZIET MUMBAI" ? ["AHMEDABAD", "JAIPUR", "MUMBAI", "PATNA", "RAIPUR"].includes(item.region)
                                                : region === "ZIET MYSORE" ? ["BENGALURU", "CHENNAI", "ERNAKULAM", "HYDERABAD"].includes(item.region)
                                                : region === item.region
                                            }).reduce((acc, item) => acc + (item.recCount - item.wcpmTotal), 0).toLocaleString("hi"),
                                    total: filteredReportData.allRegions.filter(item => {
                                            return region==="" ? true 
                                              : region === "ZIET BHUBANESWAR" ? ["BHUBANESWAR", "GUWAHATI", "KOLKATA", "RANCHI", "SILCHAR", "TINSUKIA"].includes(item.region)
                                              : region === "ZIET CHANDIGARH" ? ["CHANDIGARH", "DEHRADUN", "DELHI", "GURUGRAM", "JAMMU"].includes(item.region) 
                                              : region === "ZIET GWALIOR" ? ["AGRA", "BHOPAL", "JABALPUR", "LUCKNOW", "VARANASI"].includes(item.region)
                                              : region === "ZIET MUMBAI" ? ["AHMEDABAD", "JAIPUR", "MUMBAI", "PATNA", "RAIPUR"].includes(item.region)
                                              : region === "ZIET MYSORE" ? ["BENGALURU", "CHENNAI", "ERNAKULAM", "HYDERABAD"].includes(item.region)
                                              : region === item.region
                                          }).reduce((acc, item) => acc + item.recCount, 0).toLocaleString("hi")
                                  })
                              }
                            />
                          }
                          {chartType === "line" &&
                            <LineChart
                              chartData = {
                                [
                                  [ filteredReportData.overall.wcpmMedian ]
                                  .concat(
                                    [...new Set(filteredReportData["allRegions"].map((item) => item.region))]
                                    .filter(r => {
                                      return region==="" ? true 
                                      : region === "ZIET BHUBANESWAR" ? ["BHUBANESWAR", "GUWAHATI", "KOLKATA", "RANCHI", "SILCHAR", "TINSUKIA"].includes(r)
                                      : region === "ZIET CHANDIGARH" ? ["CHANDIGARH", "DEHRADUN", "DELHI", "GURUGRAM", "JAMMU"].includes(r) 
                                      : region === "ZIET GWALIOR" ? ["AGRA", "BHOPAL", "JABALPUR", "LUCKNOW", "VARANASI"].includes(r)
                                      : region === "ZIET MUMBAI" ? ["AHMEDABAD", "JAIPUR", "MUMBAI", "PATNA", "RAIPUR"].includes(r)
                                      : region === "ZIET MYSORE" ? ["BENGALURU", "CHENNAI", "ERNAKULAM", "HYDERABAD"].includes(r)
                                      : region === r
                                    })
                                    .map(region => filteredReportData["allRegions"].filter(item=> item.region === region)[0].wcpmMedian)
                                  )
                                ]
                              }
                              labelData = { 
                                ["OVERALL"].concat( 
                                  [...new Set(filteredReportData["allRegions"].map((item) => item.region))]
                                    .filter(r => {
                                      return region==="" ? true 
                                        : region === "ZIET BHUBANESWAR" ? ["BHUBANESWAR", "GUWAHATI", "KOLKATA", "RANCHI", "SILCHAR", "TINSUKIA"].includes(r)
                                        : region === "ZIET CHANDIGARH" ? ["CHANDIGARH", "DEHRADUN", "DELHI", "GURUGRAM", "JAMMU"].includes(r) 
                                        : region === "ZIET GWALIOR" ? ["AGRA", "BHOPAL", "JABALPUR", "LUCKNOW", "VARANASI"].includes(r)
                                        : region === "ZIET MUMBAI" ? ["AHMEDABAD", "JAIPUR", "MUMBAI", "PATNA", "RAIPUR"].includes(r)
                                        : region === "ZIET MYSORE" ? ["BENGALURU", "CHENNAI", "ERNAKULAM", "HYDERABAD"].includes(r)
                                        : region === r
                                    })
                                )
                              }
                              catLabelData={
                                [t("commonItems.chartCatLabel_line_wcpm1")]
                              }
                              title = {"WCPM - " + t("superAdmin.results.regionWiseTab.chartTitle") + " - " + superAdminInfo.allLangs[lang]}
                              xLabel = {region==="" ? t("superAdmin.results.regionWiseTab.chartXLabel_other") : t("superAdmin.results.regionWiseTab.chartXLabel_one") + " - " + region}
                              yLabel = {t("superAdmin.results.regionWiseTab.chartYLabel", {unit: "WCPM"})}
                              chartName={region!=="" ? region + " - Class-" + std : "Class-" + std}
                              chartInfo={
                                filteredReportData.allRegions[0].recCount && 
                                  t("commonItems.info_chart", { 
                                    tested: filteredReportData.allRegions.filter(item => {
                                              return region==="" ? true 
                                                : region === "ZIET BHUBANESWAR" ? ["BHUBANESWAR", "GUWAHATI", "KOLKATA", "RANCHI", "SILCHAR", "TINSUKIA"].includes(item.region)
                                                : region === "ZIET CHANDIGARH" ? ["CHANDIGARH", "DEHRADUN", "DELHI", "GURUGRAM", "JAMMU"].includes(item.region) 
                                                : region === "ZIET GWALIOR" ? ["AGRA", "BHOPAL", "JABALPUR", "LUCKNOW", "VARANASI"].includes(item.region)
                                                : region === "ZIET MUMBAI" ? ["AHMEDABAD", "JAIPUR", "MUMBAI", "PATNA", "RAIPUR"].includes(item.region)
                                                : region === "ZIET MYSORE" ? ["BENGALURU", "CHENNAI", "ERNAKULAM", "HYDERABAD"].includes(item.region)
                                                : region === item.region
                                            }).reduce((acc, item) => acc + (item.recCount - item.wcpmTotal), 0).toLocaleString("hi"),
                                    total: filteredReportData.allRegions.filter(item => {
                                            return region==="" ? true 
                                              : region === "ZIET BHUBANESWAR" ? ["BHUBANESWAR", "GUWAHATI", "KOLKATA", "RANCHI", "SILCHAR", "TINSUKIA"].includes(item.region)
                                              : region === "ZIET CHANDIGARH" ? ["CHANDIGARH", "DEHRADUN", "DELHI", "GURUGRAM", "JAMMU"].includes(item.region) 
                                              : region === "ZIET GWALIOR" ? ["AGRA", "BHOPAL", "JABALPUR", "LUCKNOW", "VARANASI"].includes(item.region)
                                              : region === "ZIET MUMBAI" ? ["AHMEDABAD", "JAIPUR", "MUMBAI", "PATNA", "RAIPUR"].includes(item.region)
                                              : region === "ZIET MYSORE" ? ["BENGALURU", "CHENNAI", "ERNAKULAM", "HYDERABAD"].includes(item.region)
                                              : region === item.region
                                          }).reduce((acc, item) => acc + item.recCount, 0).toLocaleString("hi")
                                  })
                              }
                            />
                          }
                        </>
                      }
                      {metric === "phrasing" && 
                        <>
                          {Object.keys(filteredReportData.thresholds).includes("phrasingT1") ?
                            <>
                              {chartType === "bar" &&
                                <BarChart
                                  chartData = { 
                                    [ showPhrasingNotQualified ?
                                        [ filteredReportData.overall.wcpmTotal - filteredReportData.overall.phrasingTotal, filteredReportData.overall.phrasingCat1, filteredReportData.overall.phrasingCat2, filteredReportData.overall.phrasingCat3, filteredReportData.overall.phrasingCat4, filteredReportData.overall.wcpmTotal ]
                                      :
                                        [ 0, filteredReportData.overall.phrasingCat1, filteredReportData.overall.phrasingCat2, filteredReportData.overall.phrasingCat3, filteredReportData.overall.phrasingCat4, filteredReportData.overall.phrasingTotal ]
                                    ].concat(
                                      [...new Set(filteredReportData["allRegions"].map((item) => item.region))]
                                        .filter(r => {
                                          return region==="" ? true 
                                          : region === "ZIET BHUBANESWAR" ? ["BHUBANESWAR", "GUWAHATI", "KOLKATA", "RANCHI", "SILCHAR", "TINSUKIA"].includes(r)
                                          : region === "ZIET CHANDIGARH" ? ["CHANDIGARH", "DEHRADUN", "DELHI", "GURUGRAM", "JAMMU"].includes(r) 
                                          : region === "ZIET GWALIOR" ? ["AGRA", "BHOPAL", "JABALPUR", "LUCKNOW", "VARANASI"].includes(r)
                                          : region === "ZIET MUMBAI" ? ["AHMEDABAD", "JAIPUR", "MUMBAI", "PATNA", "RAIPUR"].includes(r)
                                          : region === "ZIET MYSORE" ? ["BENGALURU", "CHENNAI", "ERNAKULAM", "HYDERABAD"].includes(r)
                                          : region === r
                                        })
                                        .map(region => filteredReportData["allRegions"].filter(item=> item.region === region)
                                        .reduce((acc, item) => {
                                          return showPhrasingNotQualified ?
                                            [ acc[0] + (item.wcpmTotal - item.phrasingTotal), acc[1] + item.phrasingCat1, acc[2] + item.phrasingCat2, acc[3] + item.phrasingCat3, acc[4] + item.phrasingCat4, acc[5] + item.wcpmTotal ]
                                          :
                                            [ acc[0] + 0, acc[1] + item.phrasingCat1, acc[2] + item.phrasingCat2, acc[3] + item.phrasingCat3, acc[4] + item.phrasingCat4, acc[5] + item.phrasingTotal ]
                                        }, [0, 0, 0, 0, 0, 0]))
                                      )
                                  }
                                  labelData = {["OVERALL"].concat( 
                                      [...new Set(filteredReportData["allRegions"].map((item) => item.region))]
                                        .filter(r => {
                                          return region==="" ? true 
                                            : region === "ZIET BHUBANESWAR" ? ["BHUBANESWAR", "GUWAHATI", "KOLKATA", "RANCHI", "SILCHAR", "TINSUKIA"].includes(r)
                                            : region === "ZIET CHANDIGARH" ? ["CHANDIGARH", "DEHRADUN", "DELHI", "GURUGRAM", "JAMMU"].includes(r) 
                                            : region === "ZIET GWALIOR" ? ["AGRA", "BHOPAL", "JABALPUR", "LUCKNOW", "VARANASI"].includes(r)
                                            : region === "ZIET MUMBAI" ? ["AHMEDABAD", "JAIPUR", "MUMBAI", "PATNA", "RAIPUR"].includes(r)
                                            : region === "ZIET MYSORE" ? ["BENGALURU", "CHENNAI", "ERNAKULAM", "HYDERABAD"].includes(r)
                                            : region === r
                                        })
                                    )
                                  }
                                  catLabelData={
                                    showPhrasingNotQualified ?
                                      [
                                      // "Phrasing > " + filteredReportData.thresholds.phrasingT1,
                                      // "Phrasing between " + (filteredReportData.thresholds.phrasingT2) + " - " + filteredReportData.thresholds.phrasingT1,
                                      // "Phrasing between 0 - " + filteredReportData.thresholds.phrasingT2
                                      t("commonItems.chartCatLabel_bar_phrasing1"), 
                                      t("commonItems.chartCatLabel_bar_phrasing2"), 
                                      t("commonItems.chartCatLabel_bar_phrasing3"), 
                                      t("commonItems.chartCatLabel_bar_phrasing4"), 
                                      t("commonItems.chartCatLabel_bar_phrasing5")
                                    ]
                                    :
                                      [
                                        "-", 
                                        t("commonItems.chartCatLabel_bar_phrasing2"), 
                                        t("commonItems.chartCatLabel_bar_phrasing3"), 
                                        t("commonItems.chartCatLabel_bar_phrasing4"), 
                                        t("commonItems.chartCatLabel_bar_phrasing5")
                                      ]
                                  }
                                  title = {"Phrasing - " + t("superAdmin.results.regionWiseTab.chartTitle") + " - " + superAdminInfo.allLangs[lang]}
                                  xLabel = {region==="" ? t("superAdmin.results.regionWiseTab.chartXLabel_other") : t("superAdmin.results.regionWiseTab.chartXLabel_one") + " - " + region}
                                  yLabel = {t("superAdmin.results.regionWiseTab.chartYLabel", {unit: "%"})}
                                  // chartColors={["#FFB5B5", "#E8CFFA", "#8CCDFF", "#AAEACB"]}
                                  chartName={region!=="" ? region + " - Class-" + std : "Class-" + std}
                                  chartInfo={
                                    filteredReportData.allRegions[0].recCount && 
                                      t("commonItems.info_chart", { 
                                        tested: filteredReportData.allRegions.filter(item => {
                                                  return region==="" ? true 
                                                    : region === "ZIET BHUBANESWAR" ? ["BHUBANESWAR", "GUWAHATI", "KOLKATA", "RANCHI", "SILCHAR", "TINSUKIA"].includes(item.region)
                                                    : region === "ZIET CHANDIGARH" ? ["CHANDIGARH", "DEHRADUN", "DELHI", "GURUGRAM", "JAMMU"].includes(item.region) 
                                                    : region === "ZIET GWALIOR" ? ["AGRA", "BHOPAL", "JABALPUR", "LUCKNOW", "VARANASI"].includes(item.region)
                                                    : region === "ZIET MUMBAI" ? ["AHMEDABAD", "JAIPUR", "MUMBAI", "PATNA", "RAIPUR"].includes(item.region)
                                                    : region === "ZIET MYSORE" ? ["BENGALURU", "CHENNAI", "ERNAKULAM", "HYDERABAD"].includes(item.region)
                                                    : region === item.region
                                                }).reduce((acc, item) => acc + (item.recCount - item.wcpmTotal), 0).toLocaleString("hi"),
                                        total: filteredReportData.allRegions.filter(item => {
                                                return region==="" ? true 
                                                  : region === "ZIET BHUBANESWAR" ? ["BHUBANESWAR", "GUWAHATI", "KOLKATA", "RANCHI", "SILCHAR", "TINSUKIA"].includes(item.region)
                                                  : region === "ZIET CHANDIGARH" ? ["CHANDIGARH", "DEHRADUN", "DELHI", "GURUGRAM", "JAMMU"].includes(item.region) 
                                                  : region === "ZIET GWALIOR" ? ["AGRA", "BHOPAL", "JABALPUR", "LUCKNOW", "VARANASI"].includes(item.region)
                                                  : region === "ZIET MUMBAI" ? ["AHMEDABAD", "JAIPUR", "MUMBAI", "PATNA", "RAIPUR"].includes(item.region)
                                                  : region === "ZIET MYSORE" ? ["BENGALURU", "CHENNAI", "ERNAKULAM", "HYDERABAD"].includes(item.region)
                                                  : region === item.region
                                              }).reduce((acc, item) => acc + item.recCount, 0).toLocaleString("hi")
                                      })
                                  }
                                />
                              }
                              {chartType === "line" &&
                                <LineChart
                                  chartData = {
                                    [
                                      [ filteredReportData.overall.phrasingMedian ]
                                      .concat(
                                        [...new Set(filteredReportData["allRegions"].map((item) => item.region))]
                                        .filter(r => {
                                          return region==="" ? true 
                                          : region === "ZIET BHUBANESWAR" ? ["BHUBANESWAR", "GUWAHATI", "KOLKATA", "RANCHI", "SILCHAR", "TINSUKIA"].includes(r)
                                          : region === "ZIET CHANDIGARH" ? ["CHANDIGARH", "DEHRADUN", "DELHI", "GURUGRAM", "JAMMU"].includes(r) 
                                          : region === "ZIET GWALIOR" ? ["AGRA", "BHOPAL", "JABALPUR", "LUCKNOW", "VARANASI"].includes(r)
                                          : region === "ZIET MUMBAI" ? ["AHMEDABAD", "JAIPUR", "MUMBAI", "PATNA", "RAIPUR"].includes(r)
                                          : region === "ZIET MYSORE" ? ["BENGALURU", "CHENNAI", "ERNAKULAM", "HYDERABAD"].includes(r)
                                          : region === r
                                        })
                                        .map(region => filteredReportData["allRegions"].filter(item=> item.region === region)[0].phrasingMedian)
                                      )
                                    ]
                                  }
                                  labelData = { 
                                    ["OVERALL"].concat( 
                                      [...new Set(filteredReportData["allRegions"].map((item) => item.region))]
                                        .filter(r => {
                                          return region==="" ? true 
                                            : region === "ZIET BHUBANESWAR" ? ["BHUBANESWAR", "GUWAHATI", "KOLKATA", "RANCHI", "SILCHAR", "TINSUKIA"].includes(r)
                                            : region === "ZIET CHANDIGARH" ? ["CHANDIGARH", "DEHRADUN", "DELHI", "GURUGRAM", "JAMMU"].includes(r) 
                                            : region === "ZIET GWALIOR" ? ["AGRA", "BHOPAL", "JABALPUR", "LUCKNOW", "VARANASI"].includes(r)
                                            : region === "ZIET MUMBAI" ? ["AHMEDABAD", "JAIPUR", "MUMBAI", "PATNA", "RAIPUR"].includes(r)
                                            : region === "ZIET MYSORE" ? ["BENGALURU", "CHENNAI", "ERNAKULAM", "HYDERABAD"].includes(r)
                                            : region === r
                                        })
                                    )
                                  }
                                  catLabelData={
                                    [t("commonItems.chartCatLabel_line_phrasing1")]
                                  }
                                  title = {"Phrasing - " + t("superAdmin.results.regionWiseTab.chartTitle") + " - " + superAdminInfo.allLangs[lang]}
                                  xLabel = {region==="" ? t("superAdmin.results.regionWiseTab.chartXLabel_other") : t("superAdmin.results.regionWiseTab.chartXLabel_one") + " - " + region}
                                  yLabel = {t("superAdmin.results.regionWiseTab.chartYLabel", {unit: "Phrasing"})}
                                  chartName={region!=="" ? region + " - Class-" + std : "Class-" + std}
                                  chartInfo={
                                    filteredReportData.allRegions[0].recCount && 
                                      t("commonItems.info_chart", { 
                                        tested: filteredReportData.allRegions.filter(item => {
                                                  return region==="" ? true 
                                                    : region === "ZIET BHUBANESWAR" ? ["BHUBANESWAR", "GUWAHATI", "KOLKATA", "RANCHI", "SILCHAR", "TINSUKIA"].includes(item.region)
                                                    : region === "ZIET CHANDIGARH" ? ["CHANDIGARH", "DEHRADUN", "DELHI", "GURUGRAM", "JAMMU"].includes(item.region) 
                                                    : region === "ZIET GWALIOR" ? ["AGRA", "BHOPAL", "JABALPUR", "LUCKNOW", "VARANASI"].includes(item.region)
                                                    : region === "ZIET MUMBAI" ? ["AHMEDABAD", "JAIPUR", "MUMBAI", "PATNA", "RAIPUR"].includes(item.region)
                                                    : region === "ZIET MYSORE" ? ["BENGALURU", "CHENNAI", "ERNAKULAM", "HYDERABAD"].includes(item.region)
                                                    : region === item.region
                                                }).reduce((acc, item) => acc + (item.recCount - item.wcpmTotal), 0).toLocaleString("hi"),
                                        total: filteredReportData.allRegions.filter(item => {
                                                return region==="" ? true 
                                                  : region === "ZIET BHUBANESWAR" ? ["BHUBANESWAR", "GUWAHATI", "KOLKATA", "RANCHI", "SILCHAR", "TINSUKIA"].includes(item.region)
                                                  : region === "ZIET CHANDIGARH" ? ["CHANDIGARH", "DEHRADUN", "DELHI", "GURUGRAM", "JAMMU"].includes(item.region) 
                                                  : region === "ZIET GWALIOR" ? ["AGRA", "BHOPAL", "JABALPUR", "LUCKNOW", "VARANASI"].includes(item.region)
                                                  : region === "ZIET MUMBAI" ? ["AHMEDABAD", "JAIPUR", "MUMBAI", "PATNA", "RAIPUR"].includes(item.region)
                                                  : region === "ZIET MYSORE" ? ["BENGALURU", "CHENNAI", "ERNAKULAM", "HYDERABAD"].includes(item.region)
                                                  : region === item.region
                                              }).reduce((acc, item) => acc + item.recCount, 0).toLocaleString("hi")
                                      })
                                  }
                                />
                              }
                            </>
                          :
                            <h3 style={{placeSelf: "center"}}>{t("commonItems.error_metricNotFound", {metric: "Phrasing"})}</h3>
                          }
                        </>
                      }
                      {metric === "pace" &&
                        <>
                          {Object.keys(filteredReportData.thresholds).includes("paceT1") ?
                            <>
                              {chartType === "bar" &&
                                <BarChart
                                  chartData = {
                                    [[
                                      filteredReportData.overall.paceCat1, filteredReportData.overall.paceCat2, filteredReportData.overall.paceCat3, filteredReportData.overall.paceCat4, filteredReportData.overall.paceTotal
                                    ]].concat(
                                      [...new Set(filteredReportData["allRegions"].map((item) => item.region))]
                                        .filter(r => {
                                          return region==="" ? true 
                                          : region === "ZIET BHUBANESWAR" ? ["BHUBANESWAR", "GUWAHATI", "KOLKATA", "RANCHI", "SILCHAR", "TINSUKIA"].includes(r)
                                          : region === "ZIET CHANDIGARH" ? ["CHANDIGARH", "DEHRADUN", "DELHI", "GURUGRAM", "JAMMU"].includes(r) 
                                          : region === "ZIET GWALIOR" ? ["AGRA", "BHOPAL", "JABALPUR", "LUCKNOW", "VARANASI"].includes(r)
                                          : region === "ZIET MUMBAI" ? ["AHMEDABAD", "JAIPUR", "MUMBAI", "PATNA", "RAIPUR"].includes(r)
                                          : region === "ZIET MYSORE" ? ["BENGALURU", "CHENNAI", "ERNAKULAM", "HYDERABAD"].includes(r)
                                          : region === r
                                        })
                                        .map(region => filteredReportData["allRegions"].filter(item=> item.region === region)
                                        .reduce((acc, item) => {
                                          return [ acc[0] + item.paceCat1, acc[1] + item.paceCat2, acc[2] + item.paceCat3, acc[3] + item.paceCat4, acc[4] + item.paceTotal ]
                                        }, [0, 0, 0, 0, 0]))
                                      )
                                  }
                                  labelData = { 
                                    ["OVERALL"].concat( 
                                      [...new Set(filteredReportData["allRegions"].map((item) => item.region))]
                                        .filter(r => {
                                          return region==="" ? true 
                                            : region === "ZIET BHUBANESWAR" ? ["BHUBANESWAR", "GUWAHATI", "KOLKATA", "RANCHI", "SILCHAR", "TINSUKIA"].includes(r)
                                            : region === "ZIET CHANDIGARH" ? ["CHANDIGARH", "DEHRADUN", "DELHI", "GURUGRAM", "JAMMU"].includes(r) 
                                            : region === "ZIET GWALIOR" ? ["AGRA", "BHOPAL", "JABALPUR", "LUCKNOW", "VARANASI"].includes(r)
                                            : region === "ZIET MUMBAI" ? ["AHMEDABAD", "JAIPUR", "MUMBAI", "PATNA", "RAIPUR"].includes(r)
                                            : region === "ZIET MYSORE" ? ["BENGALURU", "CHENNAI", "ERNAKULAM", "HYDERABAD"].includes(r)
                                            : region === r
                                        })
                                    )
                                  }
                                  catLabelData={
                                    [
                                      // "Slow", "Medium", "Fast", "Very Fast"
                                      t("commonItems.chartCatLabel_bar_pace1", {t1: (parseFloat(filteredReportData.thresholds.paceT1) + 0.1).toFixed(1)}),
                                      t("commonItems.chartCatLabel_bar_pace2", {t1: (parseFloat(filteredReportData.thresholds.paceT1) + 0.1).toFixed(1), t2: (parseFloat(filteredReportData.thresholds.paceT2) + 0.1).toFixed(1)}),
                                      t("commonItems.chartCatLabel_bar_pace3", {t1: (parseFloat(filteredReportData.thresholds.paceT2) + 0.1).toFixed(1), t2: (parseFloat(filteredReportData.thresholds.paceT3) + 0.1).toFixed(1)}),
                                      t("commonItems.chartCatLabel_bar_pace4", {t1: (parseFloat(filteredReportData.thresholds.paceT3) + 0.1).toFixed(1)})
                                    ]
                                  }
                                  title = {"Pace - " + t("superAdmin.results.regionWiseTab.chartTitle") + " - " + superAdminInfo.allLangs[lang]}
                                  xLabel = {region==="" ? t("superAdmin.results.regionWiseTab.chartXLabel_other") : t("superAdmin.results.regionWiseTab.chartXLabel_one") + " - " + region}
                                  yLabel = {t("superAdmin.results.regionWiseTab.chartYLabel", {unit: "%"})}
                                  chartName={region!=="" ? region + " - Class-" + std : "Class-" + std}
                                  chartInfo={
                                    filteredReportData.allRegions[0].recCount && 
                                      t("commonItems.info_chart", { 
                                        tested: filteredReportData.allRegions.filter(item => {
                                                  return region==="" ? true 
                                                    : region === "ZIET BHUBANESWAR" ? ["BHUBANESWAR", "GUWAHATI", "KOLKATA", "RANCHI", "SILCHAR", "TINSUKIA"].includes(item.region)
                                                    : region === "ZIET CHANDIGARH" ? ["CHANDIGARH", "DEHRADUN", "DELHI", "GURUGRAM", "JAMMU"].includes(item.region) 
                                                    : region === "ZIET GWALIOR" ? ["AGRA", "BHOPAL", "JABALPUR", "LUCKNOW", "VARANASI"].includes(item.region)
                                                    : region === "ZIET MUMBAI" ? ["AHMEDABAD", "JAIPUR", "MUMBAI", "PATNA", "RAIPUR"].includes(item.region)
                                                    : region === "ZIET MYSORE" ? ["BENGALURU", "CHENNAI", "ERNAKULAM", "HYDERABAD"].includes(item.region)
                                                    : region === item.region
                                                }).reduce((acc, item) => acc + (item.recCount - item.paceTotal), 0).toLocaleString("hi"),
                                        total: filteredReportData.allRegions.filter(item => {
                                                return region==="" ? true 
                                                  : region === "ZIET BHUBANESWAR" ? ["BHUBANESWAR", "GUWAHATI", "KOLKATA", "RANCHI", "SILCHAR", "TINSUKIA"].includes(item.region)
                                                  : region === "ZIET CHANDIGARH" ? ["CHANDIGARH", "DEHRADUN", "DELHI", "GURUGRAM", "JAMMU"].includes(item.region) 
                                                  : region === "ZIET GWALIOR" ? ["AGRA", "BHOPAL", "JABALPUR", "LUCKNOW", "VARANASI"].includes(item.region)
                                                  : region === "ZIET MUMBAI" ? ["AHMEDABAD", "JAIPUR", "MUMBAI", "PATNA", "RAIPUR"].includes(item.region)
                                                  : region === "ZIET MYSORE" ? ["BENGALURU", "CHENNAI", "ERNAKULAM", "HYDERABAD"].includes(item.region)
                                                  : region === item.region
                                              }).reduce((acc, item) => acc + item.recCount, 0).toLocaleString("hi")
                                      })
                                  }
                                />
                              }
                              {chartType === "line" &&
                                <LineChart
                                  chartData = {
                                    [
                                      [ filteredReportData.overall.paceMedian ]
                                      .concat(
                                        [...new Set(filteredReportData["allRegions"].map((item) => item.region))]
                                        .filter(r => {
                                          return region==="" ? true 
                                          : region === "ZIET BHUBANESWAR" ? ["BHUBANESWAR", "GUWAHATI", "KOLKATA", "RANCHI", "SILCHAR", "TINSUKIA"].includes(r)
                                          : region === "ZIET CHANDIGARH" ? ["CHANDIGARH", "DEHRADUN", "DELHI", "GURUGRAM", "JAMMU"].includes(r) 
                                          : region === "ZIET GWALIOR" ? ["AGRA", "BHOPAL", "JABALPUR", "LUCKNOW", "VARANASI"].includes(r)
                                          : region === "ZIET MUMBAI" ? ["AHMEDABAD", "JAIPUR", "MUMBAI", "PATNA", "RAIPUR"].includes(r)
                                          : region === "ZIET MYSORE" ? ["BENGALURU", "CHENNAI", "ERNAKULAM", "HYDERABAD"].includes(r)
                                          : region === r
                                        })
                                        .map(region => filteredReportData["allRegions"].filter(item=> item.region === region)[0].paceMedian)
                                      )
                                    ]
                                  }
                                  labelData = { 
                                    ["OVERALL"].concat( 
                                      [...new Set(filteredReportData["allRegions"].map((item) => item.region))]
                                        .filter(r => {
                                          return region==="" ? true 
                                            : region === "ZIET BHUBANESWAR" ? ["BHUBANESWAR", "GUWAHATI", "KOLKATA", "RANCHI", "SILCHAR", "TINSUKIA"].includes(r)
                                            : region === "ZIET CHANDIGARH" ? ["CHANDIGARH", "DEHRADUN", "DELHI", "GURUGRAM", "JAMMU"].includes(r) 
                                            : region === "ZIET GWALIOR" ? ["AGRA", "BHOPAL", "JABALPUR", "LUCKNOW", "VARANASI"].includes(r)
                                            : region === "ZIET MUMBAI" ? ["AHMEDABAD", "JAIPUR", "MUMBAI", "PATNA", "RAIPUR"].includes(r)
                                            : region === "ZIET MYSORE" ? ["BENGALURU", "CHENNAI", "ERNAKULAM", "HYDERABAD"].includes(r)
                                            : region === r
                                        })
                                    )
                                  }
                                  catLabelData={
                                    [t("commonItems.chartCatLabel_line_pace1")]
                                  }
                                  title = {"Pace - " + t("superAdmin.results.regionWiseTab.chartTitle") + " - " + superAdminInfo.allLangs[lang]}
                                  xLabel = {region==="" ? t("superAdmin.results.regionWiseTab.chartXLabel_other") : t("superAdmin.results.regionWiseTab.chartXLabel_one") + " - " + region}
                                  yLabel = {t("superAdmin.results.regionWiseTab.chartYLabel", {unit: "Pace"})}
                                  chartName={region!=="" ? region + " - Class-" + std : "Class-" + std}
                                  chartInfo={
                                    filteredReportData.allRegions[0].recCount && 
                                      t("commonItems.info_chart", { 
                                        tested: filteredReportData.allRegions.filter(item => {
                                                  return region==="" ? true 
                                                    : region === "ZIET BHUBANESWAR" ? ["BHUBANESWAR", "GUWAHATI", "KOLKATA", "RANCHI", "SILCHAR", "TINSUKIA"].includes(item.region)
                                                    : region === "ZIET CHANDIGARH" ? ["CHANDIGARH", "DEHRADUN", "DELHI", "GURUGRAM", "JAMMU"].includes(item.region) 
                                                    : region === "ZIET GWALIOR" ? ["AGRA", "BHOPAL", "JABALPUR", "LUCKNOW", "VARANASI"].includes(item.region)
                                                    : region === "ZIET MUMBAI" ? ["AHMEDABAD", "JAIPUR", "MUMBAI", "PATNA", "RAIPUR"].includes(item.region)
                                                    : region === "ZIET MYSORE" ? ["BENGALURU", "CHENNAI", "ERNAKULAM", "HYDERABAD"].includes(item.region)
                                                    : region === item.region
                                                }).reduce((acc, item) => acc + (item.recCount - item.paceTotal), 0).toLocaleString("hi"),
                                        total: filteredReportData.allRegions.filter(item => {
                                                return region==="" ? true 
                                                  : region === "ZIET BHUBANESWAR" ? ["BHUBANESWAR", "GUWAHATI", "KOLKATA", "RANCHI", "SILCHAR", "TINSUKIA"].includes(item.region)
                                                  : region === "ZIET CHANDIGARH" ? ["CHANDIGARH", "DEHRADUN", "DELHI", "GURUGRAM", "JAMMU"].includes(item.region) 
                                                  : region === "ZIET GWALIOR" ? ["AGRA", "BHOPAL", "JABALPUR", "LUCKNOW", "VARANASI"].includes(item.region)
                                                  : region === "ZIET MUMBAI" ? ["AHMEDABAD", "JAIPUR", "MUMBAI", "PATNA", "RAIPUR"].includes(item.region)
                                                  : region === "ZIET MYSORE" ? ["BENGALURU", "CHENNAI", "ERNAKULAM", "HYDERABAD"].includes(item.region)
                                                  : region === item.region
                                              }).reduce((acc, item) => acc + item.recCount, 0).toLocaleString("hi")
                                      })
                                  }
                                />
                              }
                            </>
                          :
                            <h3 style={{placeSelf: "center"}}>{t("commonItems.error_metricNotFound", {metric: "Pace"})}</h3>
                          }
                        </>
                      }
                      {metric === "accuracy" &&
                        <>
                          {Object.keys(filteredReportData.thresholds).includes("accuracyT1") ?
                            <>
                              {chartType === "bar" &&
                                <BarChart
                                  chartData = {
                                    [[
                                      filteredReportData.overall.accuracyCat1, filteredReportData.overall.accuracyCat2, filteredReportData.overall.accuracyCat3, filteredReportData.overall.accuracyCat4, filteredReportData.overall.accuracyTotal
                                    ]].concat(
                                      [...new Set(filteredReportData["allRegions"].map((item) => item.region))]
                                        .filter(r => {
                                          return region==="" ? true 
                                          : region === "ZIET BHUBANESWAR" ? ["BHUBANESWAR", "GUWAHATI", "KOLKATA", "RANCHI", "SILCHAR", "TINSUKIA"].includes(r)
                                          : region === "ZIET CHANDIGARH" ? ["CHANDIGARH", "DEHRADUN", "DELHI", "GURUGRAM", "JAMMU"].includes(r) 
                                          : region === "ZIET GWALIOR" ? ["AGRA", "BHOPAL", "JABALPUR", "LUCKNOW", "VARANASI"].includes(r)
                                          : region === "ZIET MUMBAI" ? ["AHMEDABAD", "JAIPUR", "MUMBAI", "PATNA", "RAIPUR"].includes(r)
                                          : region === "ZIET MYSORE" ? ["BENGALURU", "CHENNAI", "ERNAKULAM", "HYDERABAD"].includes(r)
                                          : region === r
                                        })
                                        .map(region => filteredReportData["allRegions"].filter(item=> item.region === region)
                                        .reduce((acc, item) => {
                                          return [ acc[0] + item.accuracyCat1, acc[1] + item.accuracyCat2, acc[2] + item.accuracyCat3, acc[3] + item.accuracyCat4, acc[4] + item.accuracyTotal ]
                                        }, [0, 0, 0, 0, 0]))
                                      )
                                  }
                                  labelData = { 
                                    ["OVERALL"].concat( 
                                      [...new Set(filteredReportData["allRegions"].map((item) => item.region))]
                                        .filter(r => {
                                          return region==="" ? true 
                                            : region === "ZIET BHUBANESWAR" ? ["BHUBANESWAR", "GUWAHATI", "KOLKATA", "RANCHI", "SILCHAR", "TINSUKIA"].includes(r)
                                            : region === "ZIET CHANDIGARH" ? ["CHANDIGARH", "DEHRADUN", "DELHI", "GURUGRAM", "JAMMU"].includes(r) 
                                            : region === "ZIET GWALIOR" ? ["AGRA", "BHOPAL", "JABALPUR", "LUCKNOW", "VARANASI"].includes(r)
                                            : region === "ZIET MUMBAI" ? ["AHMEDABAD", "JAIPUR", "MUMBAI", "PATNA", "RAIPUR"].includes(r)
                                            : region === "ZIET MYSORE" ? ["BENGALURU", "CHENNAI", "ERNAKULAM", "HYDERABAD"].includes(r)
                                            : region === r
                                        })
                                    )
                                  }
                                  catLabelData={
                                    [
                                      // "Poor", "Fair", "Good", "Excellent"
                                      t("commonItems.chartCatLabel_bar_accuracy1", {t1: (filteredReportData.thresholds.accuracyT1+1)}),
                                      t("commonItems.chartCatLabel_bar_accuracy2", {t1: (filteredReportData.thresholds.accuracyT1+1), t2: (filteredReportData.thresholds.accuracyT2+1)}),
                                      t("commonItems.chartCatLabel_bar_accuracy3", {t1: (filteredReportData.thresholds.accuracyT2+1), t2: (filteredReportData.thresholds.accuracyT3+1)}),
                                      t("commonItems.chartCatLabel_bar_accuracy4", {t1: (filteredReportData.thresholds.accuracyT3+1)})
                                    ]
                                  }
                                  title = {"Accuracy - " + t("superAdmin.results.regionWiseTab.chartTitle") + " - " + superAdminInfo.allLangs[lang]}
                                  xLabel = {region==="" ? t("superAdmin.results.regionWiseTab.chartXLabel_other") : t("superAdmin.results.regionWiseTab.chartXLabel_one") + " - " + region}
                                  yLabel = {t("superAdmin.results.regionWiseTab.chartYLabel", {unit: "%"})}
                                  chartName={region!=="" ? region + " - Class-" + std : "Class-" + std}
                                  chartInfo={
                                    filteredReportData.allRegions[0].recCount && 
                                      t("commonItems.info_chart", { 
                                        tested: filteredReportData.allRegions.filter(item => {
                                                  return region==="" ? true 
                                                    : region === "ZIET BHUBANESWAR" ? ["BHUBANESWAR", "GUWAHATI", "KOLKATA", "RANCHI", "SILCHAR", "TINSUKIA"].includes(item.region)
                                                    : region === "ZIET CHANDIGARH" ? ["CHANDIGARH", "DEHRADUN", "DELHI", "GURUGRAM", "JAMMU"].includes(item.region) 
                                                    : region === "ZIET GWALIOR" ? ["AGRA", "BHOPAL", "JABALPUR", "LUCKNOW", "VARANASI"].includes(item.region)
                                                    : region === "ZIET MUMBAI" ? ["AHMEDABAD", "JAIPUR", "MUMBAI", "PATNA", "RAIPUR"].includes(item.region)
                                                    : region === "ZIET MYSORE" ? ["BENGALURU", "CHENNAI", "ERNAKULAM", "HYDERABAD"].includes(item.region)
                                                    : region === item.region
                                                }).reduce((acc, item) => acc + (item.recCount - item.accuracyTotal), 0).toLocaleString("hi"),
                                        total: filteredReportData.allRegions.filter(item => {
                                                return region==="" ? true 
                                                  : region === "ZIET BHUBANESWAR" ? ["BHUBANESWAR", "GUWAHATI", "KOLKATA", "RANCHI", "SILCHAR", "TINSUKIA"].includes(item.region)
                                                  : region === "ZIET CHANDIGARH" ? ["CHANDIGARH", "DEHRADUN", "DELHI", "GURUGRAM", "JAMMU"].includes(item.region) 
                                                  : region === "ZIET GWALIOR" ? ["AGRA", "BHOPAL", "JABALPUR", "LUCKNOW", "VARANASI"].includes(item.region)
                                                  : region === "ZIET MUMBAI" ? ["AHMEDABAD", "JAIPUR", "MUMBAI", "PATNA", "RAIPUR"].includes(item.region)
                                                  : region === "ZIET MYSORE" ? ["BENGALURU", "CHENNAI", "ERNAKULAM", "HYDERABAD"].includes(item.region)
                                                  : region === item.region
                                              }).reduce((acc, item) => acc + item.recCount, 0).toLocaleString("hi")
                                      })
                                  }
                                />
                              }
                              {chartType === "line" &&
                                <LineChart
                                  chartData = {
                                    [
                                      [ filteredReportData.overall.accuracyMedian ]
                                      .concat(
                                        [...new Set(filteredReportData["allRegions"].map((item) => item.region))]
                                        .filter(r => {
                                          return region==="" ? true 
                                          : region === "ZIET BHUBANESWAR" ? ["BHUBANESWAR", "GUWAHATI", "KOLKATA", "RANCHI", "SILCHAR", "TINSUKIA"].includes(r)
                                          : region === "ZIET CHANDIGARH" ? ["CHANDIGARH", "DEHRADUN", "DELHI", "GURUGRAM", "JAMMU"].includes(r) 
                                          : region === "ZIET GWALIOR" ? ["AGRA", "BHOPAL", "JABALPUR", "LUCKNOW", "VARANASI"].includes(r)
                                          : region === "ZIET MUMBAI" ? ["AHMEDABAD", "JAIPUR", "MUMBAI", "PATNA", "RAIPUR"].includes(r)
                                          : region === "ZIET MYSORE" ? ["BENGALURU", "CHENNAI", "ERNAKULAM", "HYDERABAD"].includes(r)
                                          : region === r
                                        })
                                        .map(region => filteredReportData["allRegions"].filter(item=> item.region === region)[0].accuracyMedian)
                                      )
                                    ]
                                  }
                                  labelData = { 
                                    ["OVERALL"].concat( 
                                      [...new Set(filteredReportData["allRegions"].map((item) => item.region))]
                                        .filter(r => {
                                          return region==="" ? true 
                                            : region === "ZIET BHUBANESWAR" ? ["BHUBANESWAR", "GUWAHATI", "KOLKATA", "RANCHI", "SILCHAR", "TINSUKIA"].includes(r)
                                            : region === "ZIET CHANDIGARH" ? ["CHANDIGARH", "DEHRADUN", "DELHI", "GURUGRAM", "JAMMU"].includes(r) 
                                            : region === "ZIET GWALIOR" ? ["AGRA", "BHOPAL", "JABALPUR", "LUCKNOW", "VARANASI"].includes(r)
                                            : region === "ZIET MUMBAI" ? ["AHMEDABAD", "JAIPUR", "MUMBAI", "PATNA", "RAIPUR"].includes(r)
                                            : region === "ZIET MYSORE" ? ["BENGALURU", "CHENNAI", "ERNAKULAM", "HYDERABAD"].includes(r)
                                            : region === r
                                        })
                                    )
                                  }
                                  catLabelData={
                                    [t("commonItems.chartCatLabel_line_accuracy1")]
                                  }
                                  title = {"Accuracy - " + t("superAdmin.results.regionWiseTab.chartTitle") + " - " + superAdminInfo.allLangs[lang]}
                                  xLabel = {region==="" ? t("superAdmin.results.regionWiseTab.chartXLabel_other") : t("superAdmin.results.regionWiseTab.chartXLabel_one") + " - " + region}
                                  yLabel = {t("superAdmin.results.regionWiseTab.chartYLabel", {unit: "Accuracy"})}
                                  chartName={region!=="" ? region + " - Class-" + std : "Class-" + std}
                                  chartInfo={
                                    filteredReportData.allRegions[0].recCount && 
                                      t("commonItems.info_chart", { 
                                        tested: filteredReportData.allRegions.filter(item => {
                                                  return region==="" ? true 
                                                    : region === "ZIET BHUBANESWAR" ? ["BHUBANESWAR", "GUWAHATI", "KOLKATA", "RANCHI", "SILCHAR", "TINSUKIA"].includes(item.region)
                                                    : region === "ZIET CHANDIGARH" ? ["CHANDIGARH", "DEHRADUN", "DELHI", "GURUGRAM", "JAMMU"].includes(item.region) 
                                                    : region === "ZIET GWALIOR" ? ["AGRA", "BHOPAL", "JABALPUR", "LUCKNOW", "VARANASI"].includes(item.region)
                                                    : region === "ZIET MUMBAI" ? ["AHMEDABAD", "JAIPUR", "MUMBAI", "PATNA", "RAIPUR"].includes(item.region)
                                                    : region === "ZIET MYSORE" ? ["BENGALURU", "CHENNAI", "ERNAKULAM", "HYDERABAD"].includes(item.region)
                                                    : region === item.region
                                                }).reduce((acc, item) => acc + (item.recCount - item.accuracyTotal), 0).toLocaleString("hi"),
                                        total: filteredReportData.allRegions.filter(item => {
                                                return region==="" ? true 
                                                  : region === "ZIET BHUBANESWAR" ? ["BHUBANESWAR", "GUWAHATI", "KOLKATA", "RANCHI", "SILCHAR", "TINSUKIA"].includes(item.region)
                                                  : region === "ZIET CHANDIGARH" ? ["CHANDIGARH", "DEHRADUN", "DELHI", "GURUGRAM", "JAMMU"].includes(item.region) 
                                                  : region === "ZIET GWALIOR" ? ["AGRA", "BHOPAL", "JABALPUR", "LUCKNOW", "VARANASI"].includes(item.region)
                                                  : region === "ZIET MUMBAI" ? ["AHMEDABAD", "JAIPUR", "MUMBAI", "PATNA", "RAIPUR"].includes(item.region)
                                                  : region === "ZIET MYSORE" ? ["BENGALURU", "CHENNAI", "ERNAKULAM", "HYDERABAD"].includes(item.region)
                                                  : region === item.region
                                              }).reduce((acc, item) => acc + item.recCount, 0).toLocaleString("hi")
                                      })
                                  }
                                />
                              }
                            </>
                          :
                            <h3 style={{placeSelf: "center"}}>{t("commonItems.error_metricNotFound", {metric: "Accuracy"})}</h3>
                          }
                        </>
                      }
                    </>
                  }
                  {(reportData!=="" && lang && filteredReportData.allSchools!=="" && tabValue === 1 && region !=="") ? 
                    <>
                      {metric === "wcpm" && 
                        <>
                          {chartType === "bar" &&
                            <BarChart 
                              chartData = {
                                  [[filteredReportData.overall.wcpmCat1, filteredReportData.overall.wcpmCat2, filteredReportData.overall.wcpmCat3, filteredReportData.overall.wcpmCat4, filteredReportData.overall.wcpmCat5, filteredReportData.overall.wcpmTotal]]
                                  .concat(filteredReportData["allSchools"].map(item => 
                                    [item.wcpmCat1, item.wcpmCat2, item.wcpmCat3, item.wcpmCat4, item.wcpmCat5, item.wcpmTotal]
                                  ))
                              }
                              labelData = {["OVERALL"].concat(filteredReportData["allSchools"].map(data => data.schoolName))}
                              catLabelData={
                                [
                                  filteredReportData.thresholds.wcpmT1 < 0 ? "Invalid Entries" : t("commonItems.chartCatLabel_bar_wcpm1", {t1: 0, t2: filteredReportData.thresholds.wcpmT1}),
                                  t("commonItems.chartCatLabel_bar_wcpm1", {t1: filteredReportData.thresholds.wcpmT1+1, t2: filteredReportData.thresholds.wcpmT2}),
                                  t("commonItems.chartCatLabel_bar_wcpm1", {t1: filteredReportData.thresholds.wcpmT2+1, t2: filteredReportData.thresholds.wcpmT3}),
                                  filteredReportData.thresholds.wcpmT4 < 0 ?  t("commonItems.chartCatLabel_bar_wcpm2", {t1: filteredReportData.thresholds.wcpmT3+1}) : t("commonItems.chartCatLabel_bar_wcpm1", {t1: filteredReportData.thresholds.wcpmT3+1, t2: filteredReportData.thresholds.wcpmT4}),
                                  filteredReportData.thresholds.wcpmT4 < 0 ? "-" : t("commonItems.chartCatLabel_bar_wcpm2", {t1: filteredReportData.thresholds.wcpmT4+1})
                                ]
                              }
                              title = {"WCPM - " + t("superAdmin.results.schoolWiseTab.chartTitle") + " - " + superAdminInfo.allLangs[lang]}
                              xLabel = {t("superAdmin.results.schoolWiseTab.chartXLabel") + " - " + region}
                              yLabel = {t("superAdmin.results.schoolWiseTab.chartYLabel", {unit: "%"})}
                              chartName = {region + " - Class-" + std}
                              chartInfo={
                                (filteredReportData.allSchools[0].recCount && filteredReportData.allSchools.reduce((acc, item) => acc + (item.recCount - item.wcpmTotal), 0)!==0) && 
                                  t("commonItems.info_chart", { 
                                    tested: filteredReportData.allSchools.reduce((acc, item) => acc + (item.recCount - item.wcpmTotal), 0).toLocaleString("hi"),
                                    total: filteredReportData.allSchools.reduce((acc, item) => acc + item.recCount, 0).toLocaleString("hi")
                                  }) 
                              }
                            /> 
                          }
                          {chartType === "line" &&
                            <LineChart 
                              chartData = {[
                                [filteredReportData.overall.wcpmMedian]
                                .concat(
                                  filteredReportData["allSchools"].map(item => item.wcpmMedian)
                                )
                              ]}
                              labelData = {["OVERALL"].concat(filteredReportData["allSchools"].map(data => data.schoolName))}
                              catLabelData={
                                [t("commonItems.chartCatLabel_line_wcpm1")]
                              }
                              title = {"WCPM - " + t("superAdmin.results.schoolWiseTab.chartTitle") + " - " + superAdminInfo.allLangs[lang]}
                              xLabel = {t("superAdmin.results.schoolWiseTab.chartXLabel") + " - " + region}
                              yLabel = {t("superAdmin.results.schoolWiseTab.chartYLabel", {unit: "WCPM"})}
                              chartName = {region + " - Class-" + std}
                              chartInfo={
                                (filteredReportData.allSchools[0].recCount && filteredReportData.allSchools.reduce((acc, item) => acc + (item.recCount - item.wcpmTotal), 0)!==0) && 
                                  t("commonItems.info_chart", { 
                                    tested: filteredReportData.allSchools.reduce((acc, item) => acc + (item.recCount - item.wcpmTotal), 0).toLocaleString("hi"),
                                    total: filteredReportData.allSchools.reduce((acc, item) => acc + item.recCount, 0).toLocaleString("hi")
                                  })
                              }
                            /> 
                          }
                        </>
                      }
                      {metric === "phrasing" &&
                        <>
                          {Object.keys(filteredReportData.thresholds).includes("phrasingT1") ?
                            <>
                              {chartType === "bar" &&
                                <BarChart 
                                  chartData = {
                                                [ showPhrasingNotQualified ?
                                                    [ filteredReportData.overall.wcpmTotal - filteredReportData.overall.phrasingTotal, filteredReportData.overall.phrasingCat1, filteredReportData.overall.phrasingCat2, filteredReportData.overall.phrasingCat3, filteredReportData.overall.phrasingCat4, filteredReportData.overall.wcpmTotal ]
                                                  :
                                                    [ 0, filteredReportData.overall.phrasingCat1, filteredReportData.overall.phrasingCat2, filteredReportData.overall.phrasingCat3, filteredReportData.overall.phrasingCat4, filteredReportData.overall.phrasingTotal ]
                                                ].concat(filteredReportData["allSchools"].map(item => (
                                                      showPhrasingNotQualified ?
                                                        [(item.wcpmTotal - item.phrasingTotal), item.phrasingCat1, item.phrasingCat2, item.phrasingCat3, item.phrasingCat4, item.wcpmTotal]
                                                      :
                                                        [0, item.phrasingCat1, item.phrasingCat2, item.phrasingCat3, item.phrasingCat4, item.phrasingTotal]
                                                    ))
                                                  )
                                              }
                                  labelData = {["OVERALL"].concat(filteredReportData["allSchools"].map(data => data.schoolName))}
                                  catLabelData={showPhrasingNotQualified ?
                                      [
                                        t("commonItems.chartCatLabel_bar_phrasing1"), 
                                        t("commonItems.chartCatLabel_bar_phrasing2"), 
                                        t("commonItems.chartCatLabel_bar_phrasing3"), 
                                        t("commonItems.chartCatLabel_bar_phrasing4"), 
                                        t("commonItems.chartCatLabel_bar_phrasing5")
                                      ]
                                    :
                                      [
                                        "-", 
                                        t("commonItems.chartCatLabel_bar_phrasing2"), 
                                        t("commonItems.chartCatLabel_bar_phrasing3"), 
                                        t("commonItems.chartCatLabel_bar_phrasing4"), 
                                        t("commonItems.chartCatLabel_bar_phrasing5")
                                      ]
                                  }
                                  title = {"Phrasing - " + t("superAdmin.results.schoolWiseTab.chartTitle") + " - " + superAdminInfo.allLangs[lang]}
                                  xLabel = {t("superAdmin.results.schoolWiseTab.chartXLabel") + " - " + region}
                                  yLabel = {t("superAdmin.results.schoolWiseTab.chartYLabel", {unit: "%"})}
                                  // chartColors={["#FFB5B5", "#E8CFFA", "#8CCDFF", "#AAEACB"]}
                                  chartName = {region + " - Class-" + std}
                                  chartInfo={
                                    (filteredReportData.allSchools[0].recCount && filteredReportData.allSchools.reduce((acc, item) => acc + (
                                      item.recCount - item.wcpmTotal
                                    ), 0)!==0) && 
                                      t("commonItems.info_chart", { 
                                        tested: filteredReportData.allSchools.reduce((acc, item) => acc + (item.recCount - item.wcpmTotal), 0).toLocaleString("hi"),
                                        total: filteredReportData.allSchools.reduce((acc, item) => acc + item.recCount, 0).toLocaleString("hi")
                                      })
                                  }
                                /> 
                              }
                              {chartType === "line" &&
                                <LineChart 
                                  chartData = {[
                                    [filteredReportData.overall.phrasingMedian]
                                    .concat(
                                      filteredReportData["allSchools"].map(item => item.phrasingMedian)
                                    )
                                  ]}
                                  labelData = {["OVERALL"].concat(filteredReportData["allSchools"].map(data => data.schoolName))}
                                  catLabelData={
                                    [t("commonItems.chartCatLabel_line_phrasing1")]
                                  }
                                  title = {"Phrasing - " + t("superAdmin.results.schoolWiseTab.chartTitle") + " - " + superAdminInfo.allLangs[lang]}
                                  xLabel = {t("superAdmin.results.schoolWiseTab.chartXLabel") + " - " + region}
                                  yLabel = {t("superAdmin.results.schoolWiseTab.chartYLabel", {unit: "Phrasing"})}
                                  chartName = {region + " - Class-" + std}
                                  chartInfo={
                                    (filteredReportData.allSchools[0].recCount && filteredReportData.allSchools.reduce((acc, item) => acc + (
                                      item.recCount - item.wcpmTotal
                                    ), 0)!==0) && 
                                      t("commonItems.info_chart", { 
                                        tested: filteredReportData.allSchools.reduce((acc, item) => acc + (item.recCount - item.wcpmTotal), 0).toLocaleString("hi"),
                                        total: filteredReportData.allSchools.reduce((acc, item) => acc + item.recCount, 0).toLocaleString("hi")
                                      })
                                  }
                                /> 
                              }
                            </>
                          :
                            <h3 style={{placeSelf: "center"}}>{t("commonItems.error_metricNotFound", {metric: "Phrasing"})}</h3>
                          }
                        </>
                      }
                      {metric === "pace" &&
                        <>
                          {Object.keys(filteredReportData.thresholds).includes("paceT1") ?
                            <>
                              {chartType === "bar" &&
                                <BarChart 
                                  chartData = {
                                      [[filteredReportData.overall.paceCat1, filteredReportData.overall.paceCat2, filteredReportData.overall.paceCat3, filteredReportData.overall.paceCat4, filteredReportData.overall.paceTotal]]
                                      .concat(filteredReportData["allSchools"].map(item => 
                                        [item.paceCat1, item.paceCat2, item.paceCat3, item.paceCat4, item.paceTotal]
                                      ))
                                  }
                                  labelData = {["OVERALL"].concat(filteredReportData["allSchools"].map(data => data.schoolName))}
                                  catLabelData={
                                    [
                                      // "Slow", "Medium", "Fast", "Very Fast"
                                      t("commonItems.chartCatLabel_bar_pace1", {t1: (parseFloat(filteredReportData.thresholds.paceT1) + 0.1).toFixed(1)}),
                                      t("commonItems.chartCatLabel_bar_pace2", {t1: (parseFloat(filteredReportData.thresholds.paceT1) + 0.1).toFixed(1), t2: (parseFloat(filteredReportData.thresholds.paceT2) + 0.1).toFixed(1)}),
                                      t("commonItems.chartCatLabel_bar_pace3", {t1: (parseFloat(filteredReportData.thresholds.paceT2) + 0.1).toFixed(1), t2: (parseFloat(filteredReportData.thresholds.paceT3) + 0.1).toFixed(1)}),
                                      t("commonItems.chartCatLabel_bar_pace4", {t1: (parseFloat(filteredReportData.thresholds.paceT3) + 0.1).toFixed(1)})
                                    ]
                                  }
                                  title = {"Pace - " + t("superAdmin.results.schoolWiseTab.chartTitle") + " - " + superAdminInfo.allLangs[lang]}
                                  xLabel = {t("superAdmin.results.schoolWiseTab.chartXLabel") + " - " + region}
                                  yLabel = {t("superAdmin.results.schoolWiseTab.chartYLabel", {unit: "%"})}
                                  chartName = {region + " - Class-" + std}
                                  chartInfo={
                                    (filteredReportData.allSchools[0].recCount && filteredReportData.allSchools.reduce((acc, item) => acc + (item.recCount - item.paceTotal), 0)!==0) && 
                                      t("commonItems.info_chart", { 
                                        tested: filteredReportData.allSchools.reduce((acc, item) => acc + (item.recCount - item.paceTotal), 0).toLocaleString("hi"),
                                        total: filteredReportData.allSchools.reduce((acc, item) => acc + item.recCount, 0).toLocaleString("hi")
                                      })
                                  }
                                /> 
                              }
                              {chartType === "line" &&
                                <LineChart 
                                  chartData = {[
                                    [filteredReportData.overall.paceMedian]
                                    .concat(
                                      filteredReportData["allSchools"].map(item => item.paceMedian)
                                    )
                                  ]}
                                  labelData = {["OVERALL"].concat(filteredReportData["allSchools"].map(data => data.schoolName))}
                                  catLabelData={
                                    [t("commonItems.chartCatLabel_line_pace1")]
                                  }
                                  title = {"Pace - " + t("superAdmin.results.schoolWiseTab.chartTitle") + " - " + superAdminInfo.allLangs[lang]}
                                  xLabel = {t("superAdmin.results.schoolWiseTab.chartXLabel") + " - " + region}
                                  yLabel = {t("superAdmin.results.schoolWiseTab.chartYLabel", {unit: "Pace"})}
                                  chartName = {region + " - Class-" + std}
                                  chartInfo={
                                    (filteredReportData.allSchools[0].recCount && filteredReportData.allSchools.reduce((acc, item) => acc + (item.recCount - item.paceTotal), 0)!==0) && 
                                      t("commonItems.info_chart", { 
                                        tested: filteredReportData.allSchools.reduce((acc, item) => acc + (item.recCount - item.paceTotal), 0).toLocaleString("hi"),
                                        total: filteredReportData.allSchools.reduce((acc, item) => acc + item.recCount, 0).toLocaleString("hi")
                                      })
                                  }
                                /> 
                              }
                            </>
                          :
                            <h3 style={{placeSelf: "center"}}>{t("commonItems.error_metricNotFound", {metric: "Pace"})}</h3>
                          }
                        </>
                      }
                      {metric === "accuracy" &&
                        <>
                          {Object.keys(filteredReportData.thresholds).includes("accuracyT1") ?
                            <>
                              {chartType === "bar" &&
                                <BarChart 
                                  chartData = {
                                      [[filteredReportData.overall.accuracyCat1, filteredReportData.overall.accuracyCat2, filteredReportData.overall.accuracyCat3, filteredReportData.overall.accuracyCat4, filteredReportData.overall.accuracyTotal]]
                                      .concat(filteredReportData["allSchools"].map(item => 
                                        [item.accuracyCat1, item.accuracyCat2, item.accuracyCat3, item.accuracyCat4, item.accuracyTotal]
                                      ))
                                  }
                                  labelData = {["OVERALL"].concat(filteredReportData["allSchools"].map(data => data.schoolName))}
                                  catLabelData={
                                    [
                                      // "Poor", "Fair", "Good", "Excellent"
                                      t("commonItems.chartCatLabel_bar_accuracy1", {t1: (filteredReportData.thresholds.accuracyT1+1)}),
                                      t("commonItems.chartCatLabel_bar_accuracy2", {t1: (filteredReportData.thresholds.accuracyT1+1), t2: (filteredReportData.thresholds.accuracyT2+1)}),
                                      t("commonItems.chartCatLabel_bar_accuracy3", {t1: (filteredReportData.thresholds.accuracyT2+1), t2: (filteredReportData.thresholds.accuracyT3+1)}),
                                      t("commonItems.chartCatLabel_bar_accuracy4", {t1: (filteredReportData.thresholds.accuracyT3+1)})
                                    ]
                                  }
                                  title = {"Accuracy - " + t("superAdmin.results.schoolWiseTab.chartTitle") + " - " + superAdminInfo.allLangs[lang]}
                                  xLabel = {t("superAdmin.results.schoolWiseTab.chartXLabel") + " - " + region}
                                  yLabel = {t("superAdmin.results.schoolWiseTab.chartYLabel", {unit: "%"})}
                                  chartName = {region + " - Class-" + std}
                                  chartInfo={
                                    (filteredReportData.allSchools[0].recCount && filteredReportData.allSchools.reduce((acc, item) => acc + (item.recCount - item.accuracyTotal), 0)!==0) && 
                                      t("commonItems.info_chart", { 
                                        tested: filteredReportData.allSchools.reduce((acc, item) => acc + (item.recCount - item.accuracyTotal), 0).toLocaleString("hi"),
                                        total: filteredReportData.allSchools.reduce((acc, item) => acc + item.recCount, 0).toLocaleString("hi")
                                      })
                                  }
                                /> 
                              }
                              {chartType === "line" &&
                                <LineChart 
                                  chartData = {[
                                    [filteredReportData.overall.accuracyMedian]
                                    .concat(
                                      filteredReportData["allSchools"].map(item => item.accuracyMedian)
                                    )
                                  ]}
                                  labelData = {["OVERALL"].concat(filteredReportData["allSchools"].map(data => data.schoolName))}
                                  catLabelData={
                                    [t("commonItems.chartCatLabel_line_accuracy1")]
                                  }
                                  title = {"Accuracy - " + t("superAdmin.results.schoolWiseTab.chartTitle") + " - " + superAdminInfo.allLangs[lang]}
                                  xLabel = {t("superAdmin.results.schoolWiseTab.chartXLabel") + " - " + region}
                                  yLabel = {t("superAdmin.results.schoolWiseTab.chartYLabel", {unit: "Accuracy"})}
                                  chartName = {region + " - Class-" + std}
                                  chartInfo={
                                    (filteredReportData.allSchools[0].recCount && filteredReportData.allSchools.reduce((acc, item) => acc + (item.recCount - item.accuracyTotal), 0)!==0) && 
                                      t("commonItems.info_chart", { 
                                        tested: filteredReportData.allSchools.reduce((acc, item) => acc + (item.recCount - item.accuracyTotal), 0).toLocaleString("hi"),
                                        total: filteredReportData.allSchools.reduce((acc, item) => acc + item.recCount, 0).toLocaleString("hi")
                                      })
                                  }
                                /> 
                              }
                            </>
                          :
                            <h3 style={{placeSelf: "center"}}>{t("commonItems.error_metricNotFound", {metric: "Accuracy"})}</h3>
                          }
                        </>
                      }
                    </>
                  : (reportData!=="" && lang && tabValue === 1 && region==="") ?
                      <h3 style={{placeSelf: "center"}}>
                        {t("superAdmin.results.schoolWiseTab.noRegionSelectedInfo")}
                      </h3>
                    : 
                    (reportData!=="" && lang && tabValue === 1) && <CircularProgress color="info" sx={{placeSelf: "center"}}/>
                  }
                  {(!reportData) && <CircularProgress color="info" sx={{placeSelf: "center"}}/> }
                </>
              : <h3 style={{placeSelf: "center"}}>{reportError}</h3>
            }
            </div>
          </>
        }
      </div>
    </div>
  )
}

export default Report